import { Product } from '@axo/shared/data-access/types';
import { MarketCountryCode } from '@axo/shared/types';
import * as Sentry from '@sentry/browser';
import { TAllFormFields } from '../../../constants/formFields/formFields.d';
import formSchemas from '../../../constants/formSchemas';
import { TGetNumberOfCompletedSteps } from './getNumberOfCompletedSteps';

export const getFirstStepWithError = ({
  product,
  marketCountry,
  reloadedData,
  countrySteps,
}: {
  product: Product;
  marketCountry: MarketCountryCode;
  reloadedData: TGetNumberOfCompletedSteps['reloadedData'];
  countrySteps: TAllFormFields[];
}) => {
  const step = countrySteps.findIndex((_, index) => {
    const schema = formSchemas[marketCountry][product][index];

    if (!schema) return false;

    const result = schema.safeParse(reloadedData);

    if (!result.success) {
      console.warn(
        `IssueTrack: Step ${index + 1} failed validation:`,
        result.error.format()
      );
      Sentry.captureEvent({
        message: `Step ${index + 1} failed validation`,
        extra: {
          error: result.error.format(),
          reloadedData,
          schema,
        },
      });
    }

    return !result.success;
  });

  return step;
};
